import { HeaderPage1 } from 'theme/elements/Headers';

interface BalanceAddHeaderProps {
	title: string;
	text: string;
}

export default function BalanceAddHeader({ title, text }: BalanceAddHeaderProps) {
	return <HeaderPage1 title={title} text={text} />;
}
